var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view", attrs: { id: "salesQuery-tree-grid" } },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              ref: _vm.searchItemConfigModule,
              attrs: {
                "config-module": _vm.searchItemConfigModule,
                "is-collapse-list": true,
                "grid-options": _vm.gridOptions,
                "grid-config-module": "23150100",
                "is-append-query": true,
                reset: true,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                ),
                "source-page": "sales",
                lob: _vm.sopStateLob,
                "custom-search-items": _vm.customSearchItems,
                "hidden-search-item-filter": _vm.hiddenSearchItemFilter
              },
              on: {
                "click-more": function(value) {
                  return (_vm.isAdvancedQuery = value)
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery,
                perConfigChange: function(value) {
                  _vm.perConfigName = value
                },
                refreshGrid: function() {
                  _vm.gridRefreshId += 1
                },
                sopStateCallBack: _vm.sopStateChange,
                defaultSearchItemsChange: function(value) {
                  _vm.defaultSearchItems = value
                }
              }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "1",
                        disabled: !_vm.selectedJob || _vm.total <= 0,
                        type: "success"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toLook()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "2", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.statistics_clickHandler()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Statistics")))]
                  ),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showOperateMultiJobChargeBtn,
                          expression: "showOperateMultiJobChargeBtn"
                        }
                      ],
                      staticStyle: { margin: "0 5px" },
                      attrs: {
                        no: "chargeHandle",
                        "split-button": "",
                        type: "primary",
                        disabled: !_vm.validMultipleSelect
                      },
                      on: {
                        click: _vm.chargeHandle,
                        command: function(p) {
                          _vm.chargeCommand = p
                          _vm.chargeHandle()
                        }
                      }
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.chargeCommand) + " "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        _vm._l(_vm.operateMultiJobChargeBtns, function(item) {
                          return _c(
                            "el-dropdown-item",
                            { key: item, attrs: { command: item } },
                            [_vm._v(" " + _vm._s(item) + " ")]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.$checkPermission(["button_SalesQueryModule_salesPrint"])
                    ? _c(
                        "el-dropdown",
                        {
                          attrs: {
                            no: "3",
                            disabled:
                              !_vm.btnInfo.batchSelectFlag ||
                              !_vm.validMultipleSelect,
                            "split-button": "",
                            type: "primary"
                          },
                          on: {
                            click: function($event) {
                              _vm.onBatchPrint(_vm.$t("SeaExport.BatchPrint"))
                            },
                            command: _vm.onBatchPrint
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("SeaExport.BatchPrint")) + " "
                          ),
                          _c(
                            "el-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    command: _vm.$t(
                                      "queryJob.PrintByBusinessNumber"
                                    )
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("queryJob.PrintByBusinessNumber")
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-dropdown",
                    {
                      staticStyle: { margin: "0 5px", "font-size": "12px" },
                      attrs: { no: "3", disabled: !_vm.validMultipleSelect },
                      on: { command: _vm.batchHandle }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled:
                              !_vm.btnInfo.batchSelectFlag ||
                              !_vm.validMultipleSelect
                          }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("SeaExport.BatchProcessing")) +
                              " "
                          ),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]
                      ),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _vm.$checkPermission([
                            "button_JobBooking_BatchFillGpExplain"
                          ])
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { command: 1 } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.BatchFillGpExplain")
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: 2,
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchUnlockPayable"
                                ])
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.BatchUnlockPayableFees")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                command: 3,
                                disabled: !_vm.$checkPermission([
                                  "button_Charge_BatchLockPayable"
                                ])
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("SeaExport.BatchLockingPayableFees")
                                )
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_SMPartner_releaseApplication"],
                          expression: "['button_SMPartner_releaseApplication']"
                        }
                      ],
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          _vm.releaseApplicationDialog.visible = true
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "CargoMsg.Cargo_TemporaryDocumentReleaseApplication"
                          )
                        )
                      )
                    ]
                  ),
                  _vm.$checkPermission(["button_ledger"])
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "5px" },
                          attrs: { no: "unlockApply", type: "primary" },
                          on: { click: _vm.toUnlockApply }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.UnlockApplyBtn")))]
                      )
                    : _vm._e()
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "min-height": "350px" }
            },
            [
              _c("cargo-ag-grid", {
                staticClass: "ag-theme-balham",
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "23150100",
                  "per-config-name": _vm.perConfigName,
                  "refresh-id": _vm.gridRefreshId,
                  "grid-options": _vm.gridOptions,
                  "side-bar": {
                    toolPanels: ["columns", "filter"],
                    visible: false
                  },
                  "column-defs": _vm.finalColumnDefs,
                  "pre-column-state-callback": _vm.preColumnStateCallback,
                  "row-data": _vm.rowData,
                  "grid-params": _vm.gridParams,
                  "enable-col-resize": true,
                  "enable-sorting": true,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "has-export-role": !_vm.isSalesForSzfs
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: _vm.onGridReady,
                  columnRowGroupChanged: function() {
                    this$1.$refs[_vm.searchItemConfigModule].clickCollapseList()
                  }
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "pagination-wrapper amount-sum" }, [
            _c(
              "div",
              { staticClass: "amount-sum-right" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "amount-sum-btn",
                    attrs: { type: "text" },
                    on: { click: _vm.openChargeStatDialog }
                  },
                  [_vm._v("合计详情")]
                )
              ],
              1
            ),
            _c("div", { staticClass: "amount-sum-left" }, [
              _c("label", { staticStyle: { "margin-right": "5px" } }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.$checkPermission([
                          "role_SalesQueryModule_income"
                        ]) && !_vm.showSalePriceHc,
                      expression:
                        "$checkPermission(['role_SalesQueryModule_income']) && !showSalePriceHc"
                    }
                  ]
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("CargoMsg.Cargo_TotalRevenue") +
                          " ： " +
                          _vm.incomeTotalText
                      ) +
                      " "
                  )
                ]
              ),
              _c("label", { staticStyle: { "margin-right": "35px" } }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.$checkPermission([
                          "role_SalesQueryModule_profit"
                        ]) && !_vm.showSalePriceHc,
                      expression:
                        "$checkPermission(['role_SalesQueryModule_profit']) && !showSalePriceHc"
                    }
                  ]
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("CargoMsg.Cargo_TotalProfit") +
                          " ： " +
                          _vm.profitTotalText
                      ) +
                      " "
                  )
                ]
              ),
              _c("label", { staticStyle: { "margin-right": "20px" } }),
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_TicketCount") +
                        " ： " +
                        _vm.ticketCount
                    ) +
                    " "
                )
              ]),
              _c("label", { staticStyle: { "margin-right": "20px" } }),
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("CargoMsg.Cargo_CartonQuantity") +
                        " ： " +
                        _vm.cartonQuantity
                    ) +
                    " "
                )
              ]),
              _c("label", { staticStyle: { "margin-right": "20px" } }),
              _c("span", [
                _vm._v(
                  " " +
                    _vm._s("应收费用利息 ： " + _vm.costInterestTotalText) +
                    " "
                )
              ])
            ])
          ]),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.appendQuery,
                    expression: "!appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "23150100",
                  total: _vm.total,
                  "page-count": _vm.pageCount,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: function($event) {
                    return _vm.toQuery()
                  }
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.appendQuery,
                      expression: "appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: { total: _vm.total, layout: "total" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "job-uuid-list": _vm.jobUuidList,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.statisticsDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.statisticsDialog.visible,
                title: _vm.$t("SeaExport.Statistics"),
                width: _vm.$selectByLang("360px", "445px"),
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.statisticsDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  attrs: {
                    "label-width": _vm.$selectByLang("85px", "170px"),
                    "label-position": "left"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Slaves") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "4", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtSlaves,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtSlaves", $$v)
                          },
                          expression: "statisticsDialog.txtSlaves"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Master") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "5", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtMaster,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtMaster", $$v)
                          },
                          expression: "statisticsDialog.txtMaster"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.TotalTickets") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "6", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtCount,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtCount", $$v)
                          },
                          expression: "statisticsDialog.txtCount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.CustomerCount") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "7", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtCustomerCount,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtCustomerCount",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtCustomerCount"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "20＇" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "8", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txt20,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txt20", $$v)
                          },
                          expression: "statisticsDialog.txt20"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "40＇" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "9", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txt40,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txt40", $$v)
                          },
                          expression: "statisticsDialog.txt40"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "40HQ＇" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "10", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txt40hq,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txt40hq", $$v)
                          },
                          expression: "statisticsDialog.txt40hq"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "45＇" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "11", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txt45,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txt45", $$v)
                          },
                          expression: "statisticsDialog.txt45"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { label: "TEU" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "12", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtTeu,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtTeu", $$v)
                          },
                          expression: "statisticsDialog.txtTeu"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Weight2") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "13", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtWeight,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtWeight", $$v)
                          },
                          expression: "statisticsDialog.txtWeight"
                        }
                      }),
                      _c("span", [_vm._v("KGS")])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.Cubage") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "14", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtCubage,
                          callback: function($$v) {
                            _vm.$set(_vm.statisticsDialog, "txtCubage", $$v)
                          },
                          expression: "statisticsDialog.txtCubage"
                        }
                      }),
                      _c("span", [_vm._v("CBM")])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.ChargedWeight") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "15", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtChargeWeight,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtChargeWeight",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtChargeWeight"
                        }
                      }),
                      _c("span", [_vm._v("M/T")])
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "custom",
                      attrs: { label: _vm.$t("SeaExport.SpecifyAgentNumber") }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { no: "16", disabled: true },
                        model: {
                          value: _vm.statisticsDialog.txtdesignationAgentNum,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.statisticsDialog,
                              "txtdesignationAgentNum",
                              $$v
                            )
                          },
                          expression: "statisticsDialog.txtdesignationAgentNum"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "custom", attrs: { "label-width": "0" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { no: "17" },
                          on: {
                            change: function($event) {
                              return _vm.handleStatistics(true)
                            }
                          },
                          model: {
                            value: _vm.statisticsDialog.containShutOutJob,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.statisticsDialog,
                                "containShutOutJob",
                                $$v
                              )
                            },
                            expression: "statisticsDialog.containShutOutJob"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.ContainShutOutJob")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.statisticsDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.chargeStatDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.chargeStatDialog.visible,
                title: "合计详情",
                "custom-class": "charge-stat-dialog",
                width: "420px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.chargeStatDialog, "visible", $event)
                }
              }
            },
            [
              _vm.chargeStatDialog.currencies.length
                ? _c(
                    "div",
                    { staticClass: "charge-stat-table" },
                    [
                      _c(
                        "div",
                        { staticClass: "charge-stat-row charge-stat-head" },
                        [
                          _c("div", { staticClass: "charge-stat-cell label" }, [
                            _vm._v("币种")
                          ]),
                          _vm._l(_vm.chargeStatDialog.currencies, function(
                            currency
                          ) {
                            return _c(
                              "div",
                              {
                                key: currency,
                                staticClass: "charge-stat-cell"
                              },
                              [_vm._v(_vm._s(currency))]
                            )
                          })
                        ],
                        2
                      ),
                      _vm._l(_vm.chargeStatRows, function(row) {
                        return _c(
                          "div",
                          { key: row.key, staticClass: "charge-stat-row" },
                          [
                            _c(
                              "div",
                              { staticClass: "charge-stat-cell label" },
                              [_vm._v(_vm._s(row.label))]
                            ),
                            _vm._l(_vm.chargeStatDialog.currencies, function(
                              currency
                            ) {
                              return _c(
                                "div",
                                {
                                  key: currency,
                                  staticClass: "charge-stat-cell"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatStatAmount(
                                          row.values[currency]
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                : _c("div", { staticClass: "charge-stat-empty" }, [
                    _vm._v("暂无数据")
                  ]),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.chargeStatDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Close")))]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm.gpExplain.visible
        ? _c("add-gp-explain-dialog", {
            attrs: {
              type: _vm.gpExplain.type,
              visible: _vm.gpExplain.visible,
              "job-uuids": _vm.gpExplain.jobUuids
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.gpExplain, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.chargeTypeDialog.visible,
            title: _vm.chargeTypeDialog.title,
            width: "500px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.chargeTypeDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { margin: "30px 30px" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { size: "small" },
                  model: {
                    value: _vm.chargeTypeDialog.type,
                    callback: function($$v) {
                      _vm.$set(_vm.chargeTypeDialog, "type", $$v)
                    },
                    expression: "chargeTypeDialog.type"
                  }
                },
                _vm._l(_vm.chargeTypeDialog.data, function(option) {
                  return _c(
                    "el-radio",
                    {
                      key: option.label,
                      staticStyle: { width: "100px" },
                      attrs: { label: option.label }
                    },
                    [_vm._v(_vm._s(option.name))]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.onChargeTypeDialogConfirm }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.chargeTypeDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.addChargeDetailDialog.visible
        ? _c("add-charge-detail-dialog", {
            attrs: {
              visible: _vm.addChargeDetailDialog.visible,
              "selected-jobs": _vm.addChargeDetailDialog.selectedJobs,
              "charge-type": _vm.addChargeDetailDialog.chargeType,
              "selected-scheme": _vm.addChargeDetailDialog.selectedScheme,
              lob: _vm.lobWithFba,
              location: _vm.location
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.addChargeDetailDialog, "visible", $event)
              },
              toChangeSchema: _vm.toChangeSchema
            }
          })
        : _vm._e(),
      _c("special-charge-window", {
        attrs: {
          visible: _vm.specialChargeWindow.visible,
          "default-properties": _vm.specialChargeWindow.defaultProperties,
          location: _vm.location
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.specialChargeWindow, "visible", $event)
          }
        }
      }),
      _vm.editChargeDetailDialog.visible
        ? _c("edit-charge-detail-dialog", {
            attrs: {
              visible: _vm.editChargeDetailDialog.visible,
              "selected-jobs": _vm.editChargeDetailDialog.selectedJobs,
              "charge-type": _vm.editChargeDetailDialog.chargeType,
              "modify-special-charge":
                _vm.editChargeDetailDialog.modifySpecialCharge,
              lob: _vm.lobWithFba
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.editChargeDetailDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.deleteChargeDetailDialog.visible
        ? _c("delete-charge-detail-dialog", {
            attrs: {
              visible: _vm.deleteChargeDetailDialog.visible,
              "selected-jobs": _vm.deleteChargeDetailDialog.selectedJobs,
              "charge-type": _vm.deleteChargeDetailDialog.chargeType,
              lob: _vm.lobWithFba
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.deleteChargeDetailDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.unlockApplyDialog.visible
        ? _c("unlock-apply-dialog", {
            attrs: {
              visible: _vm.unlockApplyDialog.visible,
              "selected-jobs": _vm.unlockApplyDialog.selectedJobs
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.unlockApplyDialog, "visible", $event)
              },
              success: _vm.toQuery
            }
          })
        : _vm._e(),
      _vm.chargeSchemeBatchDialog.visible
        ? _c("charge-scheme-batch-dialog", {
            attrs: {
              visible: _vm.chargeSchemeBatchDialog.visible,
              "selected-jobs": _vm.chargeSchemeBatchDialog.selectedJobs,
              "charge-type": _vm.chargeSchemeBatchDialog.chargeType,
              job: _vm.chargeSchemeBatchDialog.job,
              "need-check-range": _vm.chargeSchemeBatchDialog.needCheckRange,
              lob: _vm.chargeSchemeBatchDialog.lob,
              "is-sea": _vm.chargeSchemeBatchDialog.isSea,
              "original-condition":
                _vm.chargeSchemeBatchDialog.originalCondition,
              "charge-scheme-is-approved":
                _vm.chargeSchemeBatchDialog.chargeSchemeIsApproved,
              location: _vm.location,
              source: _vm.chargeSchemeBatchDialog.source
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.chargeSchemeBatchDialog, "visible", $event)
              },
              selectedSchemeHandler: _vm.handleSelectedScheme
            }
          })
        : _vm._e(),
      _c("release-application-dialog", {
        attrs: {
          visible: _vm.releaseApplicationDialog.visible,
          type: "document"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.releaseApplicationDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }